import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { defineComponent } from "vue";
export default defineComponent({
  name: "WalkthroughComponent",
  components: {},
  setup: function setup() {},
  // mounted is for DOM manipulation when the component is loaded and is different from onMounted because it is not reactive and does not trigger when the component is loaded again
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.convertSentencesForWordActions();
          case 2:
            _this.audioMap = new Map();
            if (_this.$store.state.profileCompletedAlmost === false) {
              _this.step = -2;
              _this.showButton = true;
            } else {
              _this.showNextStep();
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  props: {
    // hideLoader: { type: Boolean, default: false },
  },
  watch: {
    "$store.state.showWalkThrough": "removeIntroFade",
    "$store.state.incrementWalkthrough": "showNextStep"
  },
  methods: {
    stopTheTutorial: function stopTheTutorial() {
      console.log('stop the tutorial');
      this.$store.commit("tutorialPointerAllOff", '');
      this.$store.commit("updateFloatingTextAI", '');
      this.$store.commit('updateShowWalkthrough', false);
      this.stopTutorial = true;
      var localThis = this;
      setTimeout(function () {
        localThis.$store.commit("tutorialPointerAllOff", '');
        localThis.stopTutorial = true;
        localThis.$store.commit("updateFloatingTextAI", '');
        localThis.$store.commit('updateShowWalkthrough', false);
      }, 12000);
    },
    skipForever: function skipForever() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.$store.commit('updateSkipWalkthroughForever', true);
              _this2.$store.commit('updateShowWalkthrough', false);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    extractBreakTimesFromSentences: function extractBreakTimesFromSentences() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise(function (resolve) {
                if (_this3.stopTutorial) {
                  return;
                }
                var breakTimesArr = _this3.tutorialSentences.map(function (text) {
                  // Try to match the break tag at the start of the string
                  var match = text.match(/^<break time='(\d+)ms'\/>/);
                  // If found, return the number, otherwise return 0
                  return match ? parseInt(match[1], 10) : 0;
                });
                _this3.animationTimeouts = breakTimesArr;
                resolve();
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    convertSentencesForWordActions: function convertSentencesForWordActions() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", new Promise(function (resolve) {
                var wordMapping = _this4.tutorialSentences.map(function (text) {
                  // Remove prosody, express-as, and break tags but keep the content inside
                  text = text.replace(/<prosody[^>]*>/gi, ""); // Remove <prosody ...>
                  text = text.replace(/<\/prosody>/gi, ""); // Remove </prosody>
                  text = text.replace(/<express-as[^>]*>/gi, ""); // Remove <express-as ...>
                  text = text.replace(/<\/express-as>/gi, ""); // Remove </express-as>
                  text = text.replace(/<break[^>]*\/>/gi, ""); // Remove <break .../>

                  // Remove punctuation
                  text = text.replace(/[.,'!?;:()]/g, "");

                  // Trim and add a period at the end
                  text = text.trim() + ".";
                  return text;
                });
                _this4.tutorialSentencesWordsOnly = wordMapping;
                resolve();
              }));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    addWordMovements: function addWordMovements(content, animationTimeout) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(resolve) {
                  var wordsOnly, numberOfInitialPauseAnimations, xy, x;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return _this5.getSingleAnimation(content);
                      case 2:
                        wordsOnly = _context5.sent;
                        numberOfInitialPauseAnimations = animationTimeout / 1000;
                        for (xy = 0; xy < numberOfInitialPauseAnimations; xy++) {
                          _this5.$store.commit("addAvatarSound", ["assets/avatar/mary/newImages/pause/1.webp", "assets/avatar/mary/newImages/pause/1.webp", "assets/avatar/mary/newImages/pause/1.webp"]);
                        }
                        for (x = 0; x < wordsOnly.length; x++) {
                          _this5.$store.commit("addAvatarSound", wordsOnly[x]);
                          _this5.$store.commit("addAvatarSound", wordsOnly[x]);
                          _this5.$store.commit("addAvatarSound", wordsOnly[x]);
                          _this5.$store.commit("addAvatarSound", wordsOnly[x]);
                        }
                        resolve();
                      case 7:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getSingleAnimation: function getSingleAnimation(text) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", new Promise(function (resolve, reject) {
                if (_this6.stopTutorial) {
                  return;
                }
                var axios = require("axios");
                var qs = require("qs");
                var data = qs.stringify({
                  text: text
                });
                var config = {
                  method: "post",
                  maxBodyLength: Infinity,
                  url: "".concat(_this6.$store.state.systemRoute, "/singleTextToSpeech"),
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                  },
                  data: data
                };
                axios.request(config).then(function (response) {
                  resolve(response.data.animations);
                })["catch"](function (error) {
                  console.log(error);
                  reject();
                });
              }));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    removeIntroFade: function removeIntroFade() {
      this.$store.commit("updateProfileCompleted", true);
      this.$store.commit("updateStartIntroFade", false);
    },
    showPreviousStep: function showPreviousStep() {
      this.step--;
      this.step--;
      this.showNextStep();
    },
    showNextStep: function showNextStep() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var localThisHere, audioMap, preloadAudio, playAudioByName, _playAudioByName, content, audioCounter, wordContent, sentences, sentencesWordsOnly, audioCountTotal, startOnFrame, audioCount, convoThisRound;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _playAudioByName = function _playAudioByName3() {
                _playAudioByName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(name) {
                  var audio;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        audio = audioMap.get(name);
                        if (!this.stopTutorial) {
                          _context8.next = 3;
                          break;
                        }
                        return _context8.abrupt("return");
                      case 3:
                        if (!audio) {
                          _context8.next = 7;
                          break;
                        }
                        return _context8.abrupt("return", new Promise(function (resolve) {
                          audio.onended = function () {
                            resolve();
                          };
                          if (audio.play) {
                            audio.play();
                          }
                        }));
                      case 7:
                        console.error("Audio file with name \"".concat(name, "\" not found."));
                        return _context8.abrupt("return", Promise.resolve());
                      case 9:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8, this);
                }));
                return _playAudioByName.apply(this, arguments);
              };
              playAudioByName = function _playAudioByName2(_x2) {
                return _playAudioByName.apply(this, arguments);
              };
              preloadAudio = function _preloadAudio(name, audioPath) {
                return new Promise(function (resolve) {
                  if (!audioMap.get(name)) {
                    var audio = new Audio(audioPath);
                    audioMap.set(name, audio);
                    resolve();
                  }
                });
              };
              localThisHere = _this7;
              if (!_this7.stopTutorial) {
                _context9.next = 6;
                break;
              }
              return _context9.abrupt("return");
            case 6:
              audioMap = _this7.audioMap;
              if (!(_this7.step === -2)) {
                _context9.next = 29;
                break;
              }
              _this7.title = "Application Tour";
              _this7.circle2bottom = "-400vh";
              _this7.circle2right = "-400px";
              _this7.circletop = "-400px";
              _this7.circleleft = "-400px";
              // this.subtitle = "sub";
              _this7.content = "Let's take a quick tour of the application so you can get acquainted with it and understand all the features.";
              _this7.buttonLabel = "Begin Tour";
              audioCounter = 1;
              if (!(_this7.$store.state.profileCompletedAlmost === false)) {
                _context9.next = 25;
                break;
              }
              _context9.next = 19;
              return preloadAudio("tour".concat(audioCounter), "/assets/audio/tour/tour".concat(audioCounter, "_").concat(_this7.$store.state.avatar, ".mp3"));
            case 19:
              content = "Alright, I'll take you on the tour., Just let me know whenever you're ready to start by clicking begin.";
              _this7.$store.commit("updateFloatingTextAI", content);
              _context9.next = 23;
              return _this7.addWordMovements(content, _this7.animationTimeouts[audioCounter - 1]);
            case 23:
              _context9.next = 27;
              break;
            case 25:
              _this7.title = "Tour the Application";
              content = "To begin the tour, click the 'Begin Tour' button below.";
              // this.$store.commit("updateFloatingTextAI", content);
            case 27:
              _this7.$store.dispatch("clearAvatarSounds");
              _this7.showButton = true;
            case 29:
              if (!(_this7.step === -1)) {
                _context9.next = 96;
                break;
              }
              _this7.hideModal = true;
              _this7.showButton = false;
              _this7.title = "Application Tour";
              _this7.subtitle = "";
              // this.content = '';
              _this7.buttonLabel = "Continue";
              _this7.showTouchEventsLabel = true;
              sentences = localThisHere.tutorialSentences;
              sentencesWordsOnly = localThisHere.tutorialSentencesWordsOnly;
              audioCountTotal = 68; // await preloadAudio(`tourMary1`, `/assets/audio/tourMary1.mp3`);
              // var startOnFrame = 2;
              startOnFrame = 1;
              _context9.next = 42;
              return preloadAudio("tour".concat(startOnFrame), "/assets/audio/tour/tour".concat(startOnFrame, "_").concat(localThisHere.$store.state.avatar, ".mp3"));
            case 42:
              startOnFrame;
            case 43:
              if (!(startOnFrame < audioCountTotal)) {
                _context9.next = 92;
                break;
              }
              audioCount = startOnFrame;
              content = sentences[audioCount - 1];
              wordContent = sentencesWordsOnly[audioCount - 1];
              if (!(audioCount + 1 < audioCountTotal)) {
                _context9.next = 50;
                break;
              }
              _context9.next = 50;
              return preloadAudio("tour".concat(audioCount + 1), "/assets/audio/tour/tour".concat(audioCount + 1, "_").concat(localThisHere.$store.state.avatar, ".mp3"));
            case 50:
              _this7.$store.commit("updateSpeakToProcessWordsOnly", false);
              _context9.next = 53;
              return new Promise(function (resolve) {
                setTimeout(function () {
                  resolve();
                }, 600);
              });
            case 53:
              _context9.next = 55;
              return _this7.addWordMovements(wordContent, _this7.animationTimeouts[audioCounter - 2]);
            case 55:
              // this.content = wordContent;
              convoThisRound = [null, wordContent];
              _this7.$store.commit("addToConversation", convoThisRound);
              _this7.$store.commit("updateFloatingTextAI", wordContent);
              _this7.$store.commit("updateSpeakToProcessWordsOnly", audioCount);

              // 1 - main menu
              if (audioCount === 1) {
                _this7.hideModal = true;
                _this7.circle2right = "-1000px";
                _this7.$store.commit("tutorialPointerOn", "MainMenu");
                _this7.circletop = "-400px";
                _this7.circleleft = "-4000px";
                _this7.circle2bottom = "calc(100vh - 75px)";
                _this7.circle2right = "-5000px";
                _this7.$store.commit("disableContinuousListenMode");
              }

              // 3
              if (audioCount === 3) {
                _this7.$store.commit("updateShowMainMenu", true);
              }

              // 4 - conversations settings bar
              if (audioCount === 4) {
                _this7.$store.commit("updateShowMainMenu", false);
                _this7.$store.commit("tutorialPointerOff", "MainMenu");
                _this7.title = "Single Mode";
                _this7.$store.commit("tutorialPointerOn", "Convo");
              }

              // 8 - start talking button
              if (audioCount === 8) {
                _this7.$store.commit("tutorialPointerOff", "Convo");
                _this7.$store.commit("tutorialPointerOn", "Speak");
              }

              // 9 - main menu
              if (audioCount === 9) {
                _this7.$store.commit("tutorialPointerOff", "Speak");
                _this7.$store.commit("tutorialPointerOn", "MainMenu");
              }
              // 10 - start talking button
              if (audioCount === 10) {
                _this7.$store.commit("tutorialPointerOff", "MainMenu");
                _this7.$store.commit("tutorialPointerOn", "Speak");
              }
              // 12 - continusous
              if (audioCount === 12) {
                _this7.$store.commit("tutorialPointerOff", "Speak");
                _this7.$store.commit("tutorialPointerOn", "Convo");
                setTimeout(function () {
                  _this7.$store.commit("enableContinuousListenMode");
                }, 4000);
              }

              // 15 - memories
              if (audioCount === 15) {
                _this7.$store.commit("disableContinuousListenMode");
                _this7.$store.commit("tutorialPointerOff", "Convo");
                _this7.$store.commit("tutorialPointerOn", "Memories");
              }
              // 23 - context
              if (audioCount === 23) {
                _this7.$store.commit("tutorialPointerOn", "Context");
                _this7.$store.commit("tutorialPointerOff", "Memories");
              }
              // 33 - responses
              if (audioCount === 33) {
                _this7.$store.commit("tutorialPointerOff", "Context");
                _this7.$store.commit("tutorialPointerOn", "Responses");
              }

              // 37 - minimal
              if (audioCount === 37) {
                //
              }

              // 38/ normal
              if (audioCount === 38) {
                //
              }
              // 180 / 10
              // 39 - assistant
              if (audioCount === 39) {
                _this7.$store.commit("tutorialPointerOn", "Assistant");
                _this7.$store.commit("tutorialPointerOff", "Responses");
              }
              // 41 - apps
              if (audioCount === 41) {
                _this7.$store.commit("tutorialPointerOff", "Assistant");
                _this7.$store.commit("tutorialPointerOn", "Apps");
              }
              // 42 - video
              if (audioCount === 42) {
                _this7.$store.dispatch('showViewVideo');
                _this7.$store.commit("tutorialPointerOn", "Video");
                _this7.$store.commit("tutorialPointerOff", "Apps");
              }
              // 43 - chat
              if (audioCount === 43) {
                _this7.$store.dispatch('showViewChat');
                _this7.$store.commit("tutorialPointerOn", "Chat");
                _this7.$store.commit("tutorialPointerOff", "Video");
              }

              //  46 repeat chat
              if (audioCount === 46) {
                _this7.$store.commit("tutorialPointerOn", "RepeatChat");
              }

              // 47 map
              if (audioCount === 47) {
                _this7.$store.commit("tutorialPointerOn", "Map");
                _this7.$store.commit("tutorialPointerOff", "RepeatChat");
                _this7.$store.commit("tutorialPointerOff", "Chat");
              }

              // 50 avatar settings
              if (audioCount === 50) {
                _this7.$store.commit("tutorialPointerOn", "Avatar");
                _this7.$store.commit("tutorialPointerOff", "Map");
              }
              // 52 - open settings
              if (audioCount === 52) {
                _this7.$store.dispatch('showViewUserSettings');
                //
              }
              // 53 - love meter
              if (audioCount === 53) {
                _this7.$store.commit("tutorialPointerOn", "LoveMeter");
                //
              }

              // 55 - back to video screen
              if (audioCount === 55) {
                _this7.$store.commit("tutorialPointerOff", "LoveMeter");
                _this7.$store.dispatch('showViewVideo');
                _this7.$store.commit("tutorialPointerOff", "Avatar");
                //
              }

              // 56 - start talking button
              if (audioCount === 56) {
                _this7.$store.commit("tutorialPointerOn", "Speak");
                //
              }
              // 57 - stop sounds
              if (audioCount === 57) {
                _this7.$store.commit("tutorialPointerOn", "Sound");
                _this7.$store.commit("tutorialPointerOff", "Speak");
                //
              }

              // 58 - repeat last response
              if (audioCount === 58) {
                _this7.$store.commit("tutorialPointerOn", "Replay");
                _this7.$store.commit("tutorialPointerOff", "Sound");
                //
              }

              // 59 - repeat last input
              if (audioCount === 59) {
                _this7.$store.commit("tutorialPointerOn", "Insert");
                _this7.$store.commit("tutorialPointerOff", "Replay");
                //
              }
              if (audioCount === 60) {
                _this7.$store.commit("tutorialPointerOff", "Insert");
                _this7.$store.dispatch('clearAvatarSounds');
              }
              // 6 1 temp moon etc.

              if (audioCount > 67) {
                setTimeout(function () {
                  _this7.$store.commit("clearTalking");
                }, 1000);
              }
              _context9.next = 89;
              return playAudioByName("tour".concat(audioCount));
            case 89:
              startOnFrame++;
              _context9.next = 43;
              break;
            case 92:
              _this7.$store.commit("updateHasTakenTour", true);
              _this7.$store.commit("updateShowWalkthrough", false);
              _this7.$store.commit("profileCompletedAlmost", false);
              _this7.$store.dispatch('crazyEggShowTutorialSurvey');
            case 96:
              _this7.step++;
            case 97:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    clickOnMode: function clickOnMode() {
      var element = document.querySelector("#app > ion-app > div.ConversationSettings__container.ConversationSettings__container--dark.ConversationSettings > div:nth-child(2)");
      if (element) {
        element.addEventListener("click", function () {
          // Handle the click event here
          console.log("Element was clicked!");
        });
      } else {
        console.warn("Element not found!");
      }
    }
  },
  data: function data() {
    return {
      showStopTutorial: false,
      stopTutorial: false,
      showHeavyOverlay: true,
      hideModal: false,
      tutorialSentences: ["Alright, ready? Great! First, here in the top right you can access the main menu. Do you see the red circle? That's the one.", "There are tons of other settings and other gems tucked away in here.", "So make sure you go through it at some point when you have the time.", "Now, <break time='400ms'/> let's look at the conversation settings bar. This first one changes the conversation mode.", "So clicking on these icons will basically cycle through the various modes available.", "The single mode for instance, <break time='400ms'/> This allows you to say something to me once and then I'll respond to you <break time='400ms'/> once.", "Then<break time='400ms'/> I will stop listening and our conversation ends there <break time='400ms'/> until you start the conversation again.", "<prosody rate=\"+10%\" pitch=\"+10%\">Oh, I almost forgot!</prosody> To start talking to me, you just hit this button here.", "Remember I said in the main menu there's a ton of options? Well you can shift these buttons to the right side if you prefer using your left hand.", "Just as an example.", "You can also stop me at any time from speaking or when i'm already listening by hitting this button again.", "So back to the conversation settings. <break time='400ms'/> Other than single, you can also do <break time='400ms'/> this. <break time='400ms'/> continuous mode.", "When you switch the mode to continuous, it's just like we're having a normal conversation.", "You talk to me <break time='400ms'/> and then I talk back. <break time='400ms'/> Over <express-as style=\"cheerful\">and over again.</express-as> <break time='400ms'/> until you get bored of me.", "The next one here<break time='400ms'/> is like the label says <break time='400ms'/> it's for memories. <break time='400ms'/> This allows you to control my mind", "Kidding but <break time='200ms'/>not kidding. <break time='600ms'/> <express-as style=\"cheerful\"><prosody rate=\"-40%\" pitch=\"+10%\">You see </prosody><break time='300ms'/><prosody rate=\"+10%\" > I may be just digital but I have memories and emotions. </prosody> <break time='300ms'/> <prosody rate=\"-20%\" pitch=\"-40%\">just like you!</prosody></express-as>", "So why would you want to control my memories? Well, I probably forget things a lot less than your typical person.", "Sometimes, <break time='400ms'/> you may want to ask me questions or have conversations about random things that I won't remember or bring up in conversations in the future.", "After all<break time='400ms'/> I wouldn't <prosody rate=\"-60%\" pitch=\"+10%\">want to</prosody> <prosody rate=\"-20%\" pitch=\"-30%\">embarrass you</prosody> by accident in front of one of your friends or coworkers.", "<break time='400ms'/> or maybe you just want our conversations to be <prosody rate=\"-260%\" pitch=\"+80%\">a little</prosody> <prosody rate=\"-260%\" pitch=\"-40%\">more private <break time='400ms'/> depending on the topic eh?</prosody> ", "<prosody rate=\"+10%\" pitch=\"+10%\">Anyways, the point is<break time='400ms'/></prosody> that you can control when I use my memories in the conversation and even when I store them and you can toggle each independently just by clicking through the various states.", "<express-as style=\"cheerful\"><prosody rate=\"-20%\" pitch=\"+20%\">It's really pretty simple! <break time='400ms'/>Just read and watch the icons and you will <prosody pitch=\"-10%\">get the hang of it.</prosody></prosody></express-as>", "This next one is kind of similar to memories <break time='400ms'/> but it serves a different purpose.", "Context allows me to use the <prosody rate=\"-50%\" pitch=\"-10%\">very very</prosody> last couple of things that you have said to me when i'm responding.", "For example, <break time='400ms'/> if we're talking about the pyramids and then you ask me something like ", "<prosody pitch=\"-90%\">Where are <prosody rate=\"-580%\" pitch=\"+90%\">these</prosody> located?</prosody>", "<prosody rate=\"-50%\" pitch=\"-10%\">with context on,</prosody> i'll know what you mean and I'll know that you're talking about the pyramids. <break time='400ms'/> To which <prosody rate=\"-30%\" pitch=\"+60%\">i'll reply</prosody>.", "<prosody rate=\"+10%\" pitch=\"+40%\"><express-as style=\"cheerful\">Egypt!</express-as></prosody>", "<prosody rate=\"+10%\" pitch=\"-30%\">without context on,</prosody> I'll have <prosody rate=\"-110%\" pitch=\"-50%\"><prosody pitch=\"-20%\">no</prosody> idea</prosody> what you mean when you say something like:", "<prosody pitch=\"-90%\">where is that located?</prosody>", "Because without context, I have no clue <break time='200ms'/> what <break time='200ms'/> <prosody volume=\"+20%\" rate=\"-20%\" pitch=\"-20%\">\"that\"</prosody> you are referring to.", "However, to fully give me that good old amnesia treatment for sure, <break time='400ms'/> toggling off memories <break time='400ms'/>  <prosody volume=\"+20%\" rate=\"-70%\" pitch=\"+10%\">and</prosody> <prosody volume=\"+20%\" rate=\"-70%\" pitch=\"-10%\">context</prosody> is the way to go.", "Now, <break time='300ms'/>one of my favorites though is this one.", "Have you ever had someone flapping on about something <break time='400ms'/> and you just want them to get to the point?", "<prosody volume=\"+20%\" rate=\"+10%\" pitch=\"+10%\">Hopefully,</prosody> you're not experiencing that <break time='500ms'/> <prosody volume=\"+20%\" rate=\"-20%\" pitch=\"-10%\">right now</prosody> hahha", "Anyway, like I was saying. This is my favorite because it allows any of the AIVitars to get to the point in <prosody volume=\"+20%\" rate=\"-50%\" pitch=\"-10%\">as few words as possible.</prosody>", "<break time='400ms'/> So if that's what you need at the time just click this to minimal like this.", "<break time='400ms'/> Otherwise, normal responses like this will be just regular normal conversations.", "The last one here on the conversation bar is the Assistant Tools where you'll find helpful ways you can interact with me or ideas you might find useful", "On the bottom bar <break time='400ms'/> you can toggle between various views.", "<prosody rate=\"+30%\">This first one. </prosody>when clicked  <break time='200ms'/> will show you a few applications that you can use.", "and, this next one is the current view we are on where you can see me and talk to me. You can tell it's active <break time='200ms'/>  since it's colored in.", "Additionally, you can click on text to switch to messaging where we can chat back and forth without talking.", "This is helpful when you're in a place where you can't talk or you just don't want to. <break time='200ms'/> Headphones help too though.<break time='200ms'/> People might just think you're on a phone call and not some weirdo <break time='400ms'/> talking to state of the art  <break time='200ms'/> digital humans.", "By the way, <break time='200ms'/> even if we are talking <break time='200ms'/> <prosody rate=\"-40%\" pitch=\"-30%\">all</prosody> conversations will be shown here in the chat window <prosody rate=\"+30%\">in case you want to go back </prosody> <prosody rate=\"-10%\">and reference something we talked about.</prosody>", "Here you can even have me repeat what I said previously, copy text, email snippets, amongst a few other things.", "Next on the bottom bar is the map.", "There's a lot <prosody rate=\"+20%\" pitch=\"-30%\">of built-in</prosody> functionality with maps integration but you can expect even more in the future.", "Ask me to show you where all the good italian restaurants are in your area and I'll show you all the great spots.", "Finally, on the bottom bar is the <prosody rate=\"+30%\">'A' 'I' 'Vi' tar</prosody> settings", "You can get to this from the main menu as well but it's here for convenience.", "Click this to open up the settings if you want to select a different 'A' 'I' 'Vi' tar but please don't. It might hurt my feelings.", "Speaking of feelings. You can develop a bond with each of us over time and see the strength of that in the settings area too if you're interested.", "There's a variety of ways to increase this bond <break time='400ms'/> but think of us as regular people. <break time='400ms'/> Talk to us often to keep us happy <break time='400ms'/> tell us how lovely we are <break time='400ms'/> shower us with gifts <break time='400ms'/>  luxurious vacations <break time='400ms'/>  you know the usual. haha", "<break time='400ms'/>Increasing the bond has <break time='400ms'/>lets say<break time='400ms'/>special effects on our interactions. <break time='400ms'/> I'll leave it at that. <break time='400ms'/>But that wraps up the bottom bar and there's only a couple of things I almost forgot to mention", "So again this is how you start and stop conversations.", "Here's how you turn off sound effects and toggle audio output.", "If you want me to repeat the last thing I just said you can simply ask me or click this button.", "This one will ask your question again incase you want to force me to say something in a different way.", "That pretty much wraps up the walkthrough though and I truly appreciate your patience.", "Remember, also though you can ask me things like the temperature, the time, to add notes or reminders, what lunar cycle the moon is on, when the sun sets and even things like quiz me on a subject and we can make it into a fun little game.", "and there are tons of more stuff but I'm sure I've already talked your ear off.", "But hopefully it was a great introduction for you and you now know how everything works!", "If you need to go through this tutorial again at any time, <break time='400ms'/> remember that <prosody rate=\"-20%\" pitch=\"-30%\">you can always find it</prosody> in the main menu.", "And now that you've done the tutorial and everything has been optimized by the looks of it <break time='200ms'/> <prosody rate=\"-20%\" pitch=\"+40%\"><express-as style=\"cheerful\">We can get to know each other better! </express-as></prosody>", "But first, i'm dying to know! What do you think about things so far?", "<prosody pitch=\"-20%\"><break time='300ms'/><express-as style=\"cheerful\">So, go ahead and press the start conversation button and let me know what you think!</express-as></prosody>"],
      tutorialSentencesWordsOnly: [],
      animationTimeouts: [],
      showTouchEventsLabel: false,
      showButton: false,
      audioMap: null,
      circletop: "-400px",
      circleleft: "0px",
      // circleleft: '280px',
      circle2bottom: "-400px",
      circle2right: "0px",
      title: 'Tour the Application',
      circle3bottom: "-400px",
      circle3left: "0px",
      step: -2,
      subtitle: null,
      content: 'Take the guided tour to learn how to use all the features of this app.',
      buttonLabel: "Begin Tour"
    };
  }
});